export default __webpack_public_path__ + "static/User-360c90ae6c9fb5cf8879955401b6b5a6.png";